import { Menu } from '../models/menu.type';

export function findItemById(items: Menu.Item[], id: number): Menu.Item | null {
    for (const ITEM of items) {
        if (ITEM.id === id) {
            return ITEM;
        }
        if (ITEM.items) {
            const found = findItemById(ITEM.items, id);
            if (found) {
                return found;
            }
        }
    }
    return null;
}
